import { FetchContext } from 'context/FetchContext';
import { useContext } from 'react';
import { useQuery } from 'react-query';

function useGetExamBoards(data = {}) {
  const { enabled = false } = data;
  const { privateFetch } = useContext(FetchContext);

  return useQuery(
    ['exam-info-boards'],
    () => privateFetch.get('/v1/admin/manage-podcasts/exam-info/boards').then((r) => r.data),
    { enabled, keepPreviousData: true }
  );
}

export default useGetExamBoards;
